var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Send, Check, Loader2 } from 'lucide-react';
import { tw } from '../utils/tw';
import { addSuggestion } from '../firebase/suggestions';
var SuggestionBox = function () {
    var _a = useState(''), suggestion = _a[0], setSuggestion = _a[1];
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var _c = useState('idle'), status = _c[0], setStatus = _c[1];
    var _d = useState(''), errorMessage = _d[0], setErrorMessage = _d[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!suggestion.trim()) {
                        setErrorMessage('Please enter your suggestion');
                        return [2 /*return*/];
                    }
                    setStatus('loading');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, addSuggestion({ suggestion: suggestion, email: email })];
                case 2:
                    result = _a.sent();
                    if (result.success) {
                        setStatus('success');
                        setSuggestion('');
                        setEmail('');
                        setErrorMessage('');
                        // Reset success status after 3 seconds
                        setTimeout(function () { return setStatus('idle'); }, 3000);
                    }
                    else {
                        throw new Error('Failed to submit suggestion');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setStatus('error');
                    setErrorMessage('Something went wrong. Please try again later.');
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "mt-4", children: [_jsx("h3", { className: "text-lg font-semibold mb-3", children: "Share Your Ideas" }), _jsx("p", { className: "text-slate-300 mb-4 text-sm", children: "Help us make BoredGenie better with your suggestions!" }), status === 'success' ? (_jsxs("div", { className: "bg-green-800/30 border border-green-700 rounded-lg p-3 flex items-center gap-2", children: [_jsx(Check, { size: 18, className: "text-green-400" }), _jsx("p", { className: "text-green-300 text-sm", children: "Thanks for your suggestion!" })] })) : (_jsxs("form", { onSubmit: handleSubmit, className: "space-y-3", children: [_jsx("div", { children: _jsx("textarea", { value: suggestion, onChange: function (e) { return setSuggestion(e.target.value); }, placeholder: "Share your ideas for BoredGenie...", className: "w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all text-white placeholder-slate-400", rows: 3 }) }), _jsx("div", { children: _jsx("input", { type: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, placeholder: "Email (optional)", className: "w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all text-white placeholder-slate-400" }) }), errorMessage && (_jsx("div", { className: "text-red-400 text-xs", children: errorMessage })), _jsx("button", { type: "submit", disabled: status === 'loading', className: "".concat(tw.btnPrimary, " w-full flex items-center justify-center gap-2 py-2 px-4"), children: status === 'loading' ? (_jsxs(_Fragment, { children: [_jsx(Loader2, { size: 16, className: "animate-spin" }), _jsx("span", { children: "Sending..." })] })) : (_jsxs(_Fragment, { children: [_jsx(Send, { size: 16 }), _jsx("span", { children: "Send Suggestion" })] })) })] }))] }));
};
export default SuggestionBox;
